import { StatCount } from 'components/common/stats';
import { AdminsAdd } from '.';
import { useReduxState } from 'hooks';

interface Props {
  loading?: boolean;
  existingAdminIds?: number[];
  numberOfAdmins: number;
  numberOfSuperadmins: number;
  updateAdmins: () => Promise<void>;
}

const AdminsHeader = ({
  loading,
  existingAdminIds = [],
  numberOfAdmins,
  numberOfSuperadmins,
  updateAdmins
}: Props) => {
  const {
    messages,
    serverConfig: { usersAdminLimit, usersSuperadminLimit }
  } = useReduxState();

  return (
    <div className="header">
      <div className="info">
        <StatCount
          isLarge={true}
          label={messages.usersAdmins}
          value={`${numberOfAdmins}/${usersAdminLimit}`}
          style={{ marginRight: 15 }}
        />
        <StatCount
          isLarge={true}
          label={messages.usersSuperadmins}
          value={`${numberOfSuperadmins}/${usersSuperadminLimit}`}
        />
      </div>
      <div className="add">
        {loading ? null : (
          <AdminsAdd
            existingAdminIds={existingAdminIds}
            numberOfAdmins={numberOfAdmins}
            numberOfSuperadmins={numberOfSuperadmins}
            updateAdmins={updateAdmins}
          />
        )}
      </div>

      <style jsx>{`
        .header {
          align-items: center;
          display: flex;
          flex-wrap: wrap;
        }
        .info {
          display: flex;
          flex-grow: 1;
          min-width: 0;
        }
      `}</style>
    </div>
  );
};

export default AdminsHeader;
